import PropTypes from 'prop-types';
import React, { useState } from 'react';
import withAncestry from 'ecommerce/hoc/withAncestry';

import useEditorItemContext from '../../../context/editorItemContext';
import DialogPanelBody from '../../components/dialogPanelBody';
import PersonMultiSelectTabs from '../../people/personMultiSelectTabs';
import AddPageButton from '../../components/addPageButton';
import useAncestryFamilyTreeContext from '../../../context/ancestryFamilyTreeContext';
import SelectedPersonsCounter from '../../components/selectedPersonsCounter';
import PhotoSelectPanel from './photoSelectPanel';

const PhotoPanel = ({ onAddPages, openPanel }) => {
  const { item } = useEditorItemContext();
  const { projectPersons } = useAncestryFamilyTreeContext();

  const [selectedPersons, setSelectedPersons] = useState([]);

  const handleClick = async () => {
    openPanel({
      props: { onAddPages, selectedPersons },
      renderPanel: PhotoSelectPanel,
      title: 'Choose Photo(s)',
    });
  };

  const enabled = selectedPersons.length > 0;

  return (
    <DialogPanelBody
      actionButton={
        <>
          <SelectedPersonsCounter selectedPersons={selectedPersons} />
          <AddPageButton
            icon={undefined}
            label="Choose Photo(s)"
            disabled={!enabled}
            onClick={handleClick}
          />
        </>
      }
    >
      <PersonMultiSelectTabs
        isLoading={projectPersons == null}
        onSelect={setSelectedPersons}
        people={projectPersons}
        treeId={item.additionalInfo.treeId}
      />
    </DialogPanelBody>
  );
};

PhotoPanel.propTypes = {
  openPanel: PropTypes.func.isRequired,
  onAddPages: PropTypes.func.isRequired,
};

export default withAncestry(PhotoPanel);
